export const PARTNER_INFORMATION_FIELDS = [
  {
    isCompletenessField: true,
    label: 'Primary Email Contact',
    value: 'primary_email',
  },
  {
    isCompletenessField: true,
    label: 'Primary Phone Contact',
    value: 'primary_phone',
  },
  { isCompletenessField: true, label: 'Assignee', value: 'assignee' },
  {
    isCompletenessField: true,
    label: 'Assignee Email Linked',
    value: 'assignee_email_linked',
  },
  { label: 'Disabled Email Contact', value: 'disabled_email' },
  { label: 'Disabled Phone Contact', value: 'disabled_phone' },
];
